var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSvgPin = function SvgSvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 15.003a5.256 5.256 0 0 1-5.25-5.25A5.256 5.256 0 0 1 12 4.503a5.256 5.256 0 0 1 5.25 5.25 5.256 5.256 0 0 1-5.25 5.25m0-9a3.754 3.754 0 0 0-3.75 3.75 3.754 3.754 0 0 0 3.75 3.75 3.754 3.754 0 0 0 3.75-3.75A3.754 3.754 0 0 0 12 6.003"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.999 23.901c-.261 0-.518-.068-.743-.197a21 21 0 0 1-5.142-4.209c-2.564-2.922-3.864-6.2-3.864-9.743 0-5.376 4.374-9.75 9.75-9.75s9.75 4.374 9.75 9.75c0 3.544-1.3 6.822-3.865 9.744a21 21 0 0 1-5.142 4.208 1.5 1.5 0 0 1-.744.197M12 1.503c-4.549 0-8.25 3.701-8.25 8.25 0 1.861.595 8.272 8.25 12.649 7.655-4.372 8.25-10.787 8.25-12.649 0-4.549-3.701-8.25-8.25-8.25"
  })));
};
export default SvgSvgPin;